import axios from '../../localAxios';
import { v3QuizURL } from '../url';
import { normalizeQuizzesResponse } from './normalize';
import { QuizzesResponse } from './types';

export async function getQuizzes() {
  const { data } = await axios.get<QuizzesResponse>(v3QuizURL().href);
  return normalizeQuizzesResponse(data);
}
